export default "__VITE_ASSET__BqjCHcjZ__"